/**
 * Usage:
 *
 * insertHeadTags([
 *   name: 'script',
 *   noRemove: true,
 *   attributes: {
 *     src: 'https://script-src.js'
 *   }
 * ], onLoad)
 *
 */
export default (() => {
  let mountedEls = [];
  let loadedCount = 0;

  function isMounted(el) {
    return mountedEls.some(mountedEl => mountedEl.isEqualNode(el));
  }

  function didAllLoad() {
    return mountedEls.length === loadedCount;
  }

  function removeEl(el) {
    document.head.removeChild(el);
    mountedEls = mountedEls.filter(mountedEl => !el.isEqualNode(mountedEl));
    loadedCount--;
  }

  function createEl(tagDefinition) {
    const el = document.createElement(tagDefinition.name);

    Object.entries(tagDefinition.attributes).forEach(([name, value]) => {
      el.setAttribute(name, value);
    });

    return el;
  }

  return function insertHeadTags(tagDefinitions, onLoad = () => {}) {
    const fragmentToAppend = document.createDocumentFragment();
    const elsToRemove = [];

    tagDefinitions.forEach(tagDefinition => {
      const el = createEl(tagDefinition);

      if (isMounted(el)) {
        return;
      }

      if (!tagDefinition.noRemove) {
        elsToRemove.push(el);
      }

      el.addEventListener('load', () => {
        loadedCount++;
        if (didAllLoad()) {
          onLoad();
        }
      });

      mountedEls.push(el);

      fragmentToAppend.appendChild(el);
    });

    if (didAllLoad()) {
      onLoad();
    }

    document.head.appendChild(fragmentToAppend);

    return function removeHeadTags() {
      elsToRemove.forEach(removeEl);
    };
  };
})();
